import { registerPlugin } from '@capacitor/core';

// Define the data structure for golf game data
export interface GolfGameLiveData {
  gameName: string;
  playerName: string;
  currentHole: number;
  totalHoles: number;
  par: number;
  hcp?: number;
  holeName?: string;
  score: number;
  courseName: string;
  courseLayout: string;
}

// Define plugin interface
interface MGPLiveActivityPlugin {
  startLiveActivity(options: { gameData: GolfGameLiveData }): Promise<{ activityId: string }>;
  updateLiveActivity(options: { activityId: string, gameData: GolfGameLiveData }): Promise<void>;
  endLiveActivity(options: { activityId: string }): Promise<void>;
  getAllActivities(): Promise<{ activityIds: string[] }>;
}

// Register the plugin with Capacitor
const LiveActivity = registerPlugin<MGPLiveActivityPlugin>('MGPLiveActivity');

export { LiveActivity };
